import './hero.less';
import Slider from '../slider/index';
import HeroItem from './hero-item';

// trim-below
import React from 'react';
import PropTypes from 'prop-types';
import block from 'bem-cn-lite';

const b = block('hero');

const Hero = ({list, title}) => {
	if (list.length === 1) {
		return (
			<div className={b({short: true})}>
				<HeroItem h1={true} {...list[0]} index={1} />
			</div>
		);
	}

	return (
		<div className={b()}>
			<h1 className="visuallyhidden">{title}</h1>
			<Slider
				className={b()}
				count={list.length}
				mode="gallery"
				autoplay={true}
				placeholders={
					list.map((item, index) => (
						<HeroItem key={index} {...item} index={index} />
					))
				}
			/>
		</div>
	);
}

Hero.propTypes = {
	list: PropTypes.array.isRequired,
	title: PropTypes.string
};

export default Hero;



// WEBPACK FOOTER //
// ./src/components/hero/index.jsx